













































import { TeipNotifications } from '@/util/teipNotifications';
import root from '@/store/types/root';
import company_commerce from '@/store/types/company_commerce';
import actionConfirm from '@/components/modals/actionConfirm.vue';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';

export default Vue.extend({
  name: 'UpdateStatusCompanyCommerce',
  components: {
    actionConfirm,
  },
  data() {
    return {
      status: null,
      confirmAction: false,
      message: `Ten en cuenta que si desactivas este ${this.$t('menu.commerce.singular.informal')}, no
              podrá realizar transacciones con teip.`,
    };
  },
  created(): void {
    this.$data.status =
      this.singleCompanyCommerce.status === 'active';

    if (!this.$data.status) {
      this.$data.message = `Activa el ${this.$t('menu.commerce.singular.informal')} para que empiece a
      realizar transacciones con teip.`;
    }
  },
  computed: {
    ...mapGetters({
      getProcess: root.getters.GET_START_PROCESS,
      singleCompanyCommerce: `companyCommerceModule/${company_commerce.getters.GET_SINGLE_COMPANY_COMMERCE}`,
    }),
  },
  methods: {
    ...mapActions({
      updateCompanyCommerce: `companyCommerceModule/${company_commerce.actions.UPDATE_COMPANY_COMMERCE}`,
    }),
    confirmChangeStatus(): void {
      this.$data.confirmAction = true;
    },
    updateStatus(): void {
      this.$data.confirmAction = false;
      const status = this.$data.status ? 'active' : 'inactive';
      const data = {
        company_commerce_id: this.singleCompanyCommerce.id,
        data: {
          status,
        },
      };

      this.updateCompanyCommerce(data)
        .then(() => {
          this.$emit('success', true);
        })
        .catch(() => {
          const notification = new TeipNotifications();
          notification.warning('¡Error!', 'Algo ha salido mal :(');
        })
        .finally(() => {
          this.$data.confirmAction = false;
        });
    },
  },

});
